// extracted by mini-css-extract-plugin
export default {"label":"GOFNnj","pad":"cdDKVN","wrapper":"OUOphd","form-field":"nRYWD_","formField":"nRYWD_","asterisk":"vJWiXt"};